import { render, staticRenderFns } from "./FormIndicador.vue?vue&type=template&id=3f596247&scoped=true"
import script from "./FormIndicador.vue?vue&type=script&lang=js"
export * from "./FormIndicador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f596247",
  null
  
)

export default component.exports